import { createApiSaga } from "redux-store/api-sagas";
import { userService } from "service/user";

import {
  ADMIN_EDIT_USER,
  CHANGE_PASSWORD,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  FORGOT_PASSWORD,
  INVITE_USER,
  REGISTER_USER,
  RESET_PASSWORD,
  USER_INVITE_DETAILS,
} from "./actions";

const adminUserEditSaga = createApiSaga({
  service: userService.adminEdit,
  serviceName: "userService.adminEdit",
  fetchAction: ADMIN_EDIT_USER,
  successAction: EDIT_USER_SUCCESS,
  reload: false,
});

const changePasswordSaga = createApiSaga({
  service: userService.changePassword,
  serviceName: "userService.changePassword",
  fetchAction: CHANGE_PASSWORD,
  reload: false,
});

const forgotPasswordSaga = createApiSaga({
  service: userService.forgotPassword,
  serviceName: "userService.forgotPassword",
  fetchAction: FORGOT_PASSWORD,
  reload: false,
});

const resetPasswordSaga = createApiSaga({
  service: userService.resetPassword,
  serviceName: "userService.resetPassword",
  fetchAction: RESET_PASSWORD,
  reload: false,
});

const userEditSaga = createApiSaga({
  service: userService.edit,
  serviceName: "userService.edit",
  fetchAction: EDIT_USER,
  successAction: EDIT_USER_SUCCESS,
  reload: false,
});

const userInviteSaga = createApiSaga({
  service: userService.invite,
  serviceName: "userService.invite",
  fetchAction: INVITE_USER,
  reload: false,
});

const userInviteDetailsSaga = createApiSaga({
  service: userService.inviteDetails,
  serviceName: "userService.inviteDetails",
  fetchAction: USER_INVITE_DETAILS,
  reload: false,
});

const userRegistrationSaga = createApiSaga({
  service: userService.register,
  serviceName: "userService.register",
  fetchAction: REGISTER_USER,
  reload: false,
});

export {
  adminUserEditSaga,
  changePasswordSaga,
  forgotPasswordSaga,
  resetPasswordSaga,
  userEditSaga,
  userInviteDetailsSaga,
  userInviteSaga,
  userRegistrationSaga,
};
